import "./styles.scss";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCircleExclamation } from "react-icons/fa6";

import ButtonMB from "../../Buttons/Button";

function Alert({ title, type = "", titleButton, onClick }) {
  const { t } = useTranslation();

  return (
    <div className="affiliateAlertContainer">
      <p className="affiliateAlertTitle">
        <FaCircleExclamation size={14} color="#FF2D00" />
        {t(title)}
      </p>

      {type === "affiliate" ? (
        <Link to="/affiliate">
          <ButtonMB className="affiliateAlertButton" title={t(titleButton)} onClick={onClick} />
        </Link>
      ) : (
        <ButtonMB className="affiliateAlertButton" title={t(titleButton)} onClick={onClick} />
      )}
    </div>
  );
}

export default Alert;
